import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, MaybeAsync, Router, RouterStateSnapshot, UrlTree }from '@angular/router';
import { AppStoreService } from '@core/store/app-store.service';
import { ClientDto } from '@core/api';
import { PermissionType } from '@core/enums/permission-type.enum';
import { PermissionTypeService } from '@core/service/permission-type.service';
import { Token } from '@core/models/token.model';
import { UserProfileService } from '@core/service/user-profile.service';

@Injectable({
    providedIn: 'root',
})
export class NoDapClientGuard {
    private readonly _appStoreService = inject(AppStoreService);
    private readonly _router = inject(Router);
    private readonly _permissionTypeService = inject(PermissionTypeService);
    private readonly _userProfileService = inject(UserProfileService);

    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): MaybeAsync<boolean | UrlTree> {
        const client = this._userProfileService.client();
        const hasRequired = this._permissionTypeService.userHasAllPermissionTypes([PermissionType.CLIENT_REGISTRATION]);

        if(client != null && hasRequired){
            if(!this.hasStates(client)){
                return false;
            }

            const token = this._appStoreService.token();
            const stateRedirect = this.checkState(client, token);

            if(stateRedirect != null){
                return stateRedirect;
            }

            this.checkSubState(client, token);

            return true;
        }

        return true;
    }

    private hasStates(client: ClientDto): boolean{
        return client.state !== undefined && client.subState !== undefined;
    }

    private checkState(client: ClientDto, token: Token | null): UrlTree | null{
        if(
            client.state !== undefined
            && token != null
            && (
                client.state === ClientDto.StateEnum.Deleted
                || client.state === ClientDto.StateEnum.UnderDeletion
            )
        ){
            token.privileges = [PermissionType.INACTIVE_CLIENT];
            return this._router.createUrlTree(['/reactivate']);
        }
        return null;
    }

    private checkSubState(client: ClientDto, token: Token | null){
        if(
            client.state !== undefined
            && client.subState !== undefined
            && token != null
            && (
                client.state === ClientDto.StateEnum.Active
                || client.state === ClientDto.StateEnum.UnderRegistration
            )
            && client.subState !== ClientDto.SubStateEnum.ContractSigned
        ){
            token.privileges.push(PermissionType.NO_SIGNED_CONTRACT_CLIENT);
        }
    }
}
